module.exports = __webpack_public_path__ + "img/Group3@2x (2).1a105a6f.png";